  document.addEventListener('DOMContentLoaded', () => {
    const CollectionFiltersForm = {
      init() {
        this.filterForm = document.querySelector('#filter-form');
        this.collectionSection = document.querySelector('.collection-page');
        if (!this.filterForm || !this.collectionSection) return;

        // If no products are found, show the no products found message
        this.productGrid = document.querySelector('.collection-products');
        if (this.productGrid && this.productGrid.children.length === 0) {
          this.noProductsFound();
        } 
        
        this.formState(); // Is the filter form open?
        this.bindEvents();
        this.initSortDropdown();
        this.initFilterToggles();
        this.initFilterClose();
      },

      formState() {
        // check localStorage to see if the filter form is open
        const formState = localStorage.getItem('vel_sidebarFiltersState');
        const sidebarFilters = document.querySelector('.sidebar-filters_wrapper');
        // if formState is null and the user is on desktop, open the filter form

        // REQUEST TO HAVE CLOSED ON INITIAL LOAD
        // if (window.innerWidth >= 768) {
        //   // only auto open the filters if we are on desktop or if the user has already set the formState to open.  
        //   if (formState === null || formState === 'open') {
        //     sidebarFilters.classList.remove('closed');
        //     document.querySelector('.filter-toggle').classList.add('closed');
        //   }
        // }

        if (formState === 'open') {
          sidebarFilters.classList.remove('closed');
          document.querySelector('.filter-toggle').classList.add('closed');
        }
      },
      noProductsFound() {
          // This function displays the no products found message.
          const noProductsWrapper = document.createElement('div');
          noProductsWrapper.className = 'no-products-found';
          
          const noProductsHeading = document.createElement('h4');
          const noProductsText = document.createElement('p');
          noProductsHeading.textContent = 'No Products Found';
          noProductsText.textContent = 'We couldn\'t find any products matching your filters. Please try again with different filters.';
          
          noProductsWrapper.appendChild(noProductsHeading);
          noProductsWrapper.appendChild(noProductsText);
          this.productGrid.appendChild(noProductsWrapper);
      },

      bindEvents() {
        this.filterForm.addEventListener('input', (event) => this.onFilterChange(event));

      const applyFiltersBtn = document.querySelector('#apply-filters_btn');
      if (applyFiltersBtn) {
        applyFiltersBtn.addEventListener('click', (event) => {
          event.preventDefault();
          this.animateSidebarFilters();
          const sidebarFilters = document.querySelector('.sidebar-filters_wrapper');
          sidebarFilters.classList.add('closed');
          document.querySelector('.filter-toggle').classList.remove('closed');
          localStorage.setItem('vel_sidebarFiltersState', 'closed');
        });
      }
      },

      initSortDropdown() {
        const sortDropdown = document.querySelector('.sort-dropdown');
        if (!sortDropdown) return;
        sortDropdown.addEventListener('click', (event) => this.onSortChange(event));
      },

      onSortChange(event) {
        // get the current url params
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);

        // clear the sort_by param
        params.delete('sort_by');
        // clear the page param
        params.delete('page');

        // This is the value of the sort dropdown
        const sortValue = event.target.dataset.value;

        // append the sort_by param to the url
        params.append('sort_by', sortValue);

        this.renderSection(params.toString());
      },

      onFilterChange(event) {
        const url = new URL(window.location.href);
        const filterParams = new URLSearchParams(url.search);
        
        // Clear existing filter parameters and pagination
        const keys = Array.from(filterParams.keys());
        keys.forEach(key => {
          if (key.startsWith('filter.') || key === 'page') {
            filterParams.delete(key);
          }
        });

        // Add new filter parameters
        const checkedInputs = this.filterForm.querySelectorAll('input[type="checkbox"]:checked');
        checkedInputs.forEach(input => {
          filterParams.append(input.name, input.value);
        });

        this.renderSection(filterParams.toString());
      },

      initFilterToggles() {
        const filterCategories = document.querySelectorAll('.filter-group');
        if (!filterCategories) return;
        
        // Get stored positions array once, outside the loop
        let filterPositions = [];
        const storedPositions = localStorage.getItem('vel_filterPositions');
        
        if (storedPositions) {
          filterPositions = JSON.parse(storedPositions);
        }
        
        filterCategories.forEach(category => {
          // Check if this filter should be open
          const position = category.dataset.filterPosition;
          if (filterPositions.includes(position)) {
            category.classList.add('open');
            const arrow = category.querySelector('img');
            if (arrow) arrow.classList.add('rotate-180');
          }

          // Listen for both click and checkbox changes
          const handleInteraction = () => {
            const isOpen = category.classList.toggle('open');
            
            // Update filterPositions array
            if (isOpen) {
              if (!filterPositions.includes(position)) {
                filterPositions.push(position);
              }
            } else {
              // Remove the position when closing
              filterPositions = filterPositions.filter(pos => pos !== position);
            }
            
            // Save updated array
            localStorage.setItem('vel_filterPositions', JSON.stringify(filterPositions));
            
            // Handle arrow rotation
            const arrow = category.querySelector('img');
            if (arrow) {
              arrow.classList.toggle('rotate-180', isOpen);
            }
          };

          // Handle clicks on the category header only
          category.addEventListener('click', (event) => {
              handleInteraction();
          });
        });
      },

      animateSidebarFilters() {
        const sidebarFilters = document.querySelector('.sidebar-filters_wrapper');
        sidebarFilters.classList.add('animate');
        setTimeout(() => {
          sidebarFilters.classList.remove('animate');
        }, 300); // Match the CSS transition duration
      },

      initFilterClose() {

        // This is the button that toggles the filters on desktop.
        const filterToggle = document.querySelector('.filter-toggle');
        if (!filterToggle) return;

        // This is the button that toggles the sort dropdown.
        const sortToggle = document.querySelector('.sort-toggle');
        if (!sortToggle) return;

        const sidebarFilters = document.querySelector('.sidebar-filters_wrapper');
        const filterButton = document.querySelector('.filter-toggle');
        if (sidebarFilters) {
        filterToggle.addEventListener('click', () => {
            this.animateSidebarFilters();
            sidebarFilters.classList.toggle('closed');
            filterButton.classList.toggle('closed');
            // Save sidebar filter state to localStorage
            const isFiltersClosed = sidebarFilters.classList.contains('closed');
            localStorage.setItem('vel_sidebarFiltersState', isFiltersClosed ? 'closed' : 'open');
        });

        sortToggle.addEventListener('click', () => {
            const sortDropdown = document.querySelector('.sort-dropdown');
            sortDropdown.classList.toggle('hidden');
        });

        // This is the button that toggles the filters on mobile.
        const filterClose = document.querySelector('.filter-close');
        if (!filterClose) return;

        filterClose.addEventListener('click', () => {
          this.animateSidebarFilters();
          sidebarFilters.classList.toggle('closed');
          filterButton.classList.remove('closed');
          localStorage.setItem('vel_sidebarFiltersState', 'closed');
        });
      }

      },

      async renderSection(searchParams) {
        const sectionId = this.collectionSection.dataset.sectionId;
        const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
        
        try {
          const response = await fetch(url);
          const html = await response.text();
          
          window.history.pushState({ searchParams }, '', `${window.location.pathname}?${searchParams}`);
          
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newContent = doc.querySelector('.collection-whole');
          
          if (newContent) {
            document.querySelector('.collection-whole').innerHTML = newContent.innerHTML;
            // Re-initialize after content update
            this.init();
          }
        } catch (error) {
          console.error('Error updating filters:', error);
        }
      }
    };

    // Initialize the filters form
    CollectionFiltersForm.init();
  });
